import {
  toTypedRxJsonSchema,
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxJsonSchema,
  RxDocument,
  RxCollection,
} from 'rxdb';

const configSchemaLiteral = {
  version: 0,
  primaryKey: 'appId',
  type: 'object',
  properties: {
    appId: {
      type: 'string',
      maxLength: 32,
    },
    refreshToken: {
      type: 'string',
    },
  },
  required: ['appId'],
} as const;

const schemaTyped = toTypedRxJsonSchema(configSchemaLiteral);

export type ConfigDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const configSchema: RxJsonSchema<ConfigDocType> = configSchemaLiteral;

export type ConfigDocument = RxDocument<ConfigDocType>;

export type ConfigCollection = RxCollection<ConfigDocument>;
